<div class="w-full flex flex-wrap items-center">
  <div
    class="w-full pb-2 flex flex-wrap items-center justify-between border-b border-gray-100 dark:border-gray-600"
  >
    <p class="w-full text-sm md:text-base font-medium text-gray-900">
      {{ alertConfig.title }}
    </p>
    <p class="w-full text-sm text-gray-500 mt-2">{{ alertConfig.subTitle }}</p>
  </div>

  <!-- ? Actions -->
  <div class="w-full mt-2 flex flex-wrap items-center justify-between">
    <ng-container *ngFor="let button of buttons; let i = index">
      <div class="w-1/2 px-1 md:px-2">
        <button
          tabindex="-1"
          class="w-full h-12 !text-xs md:!text-sm !px-2"
          [class]="button.classes"
          (click)="close(button.type)"
        >
          {{ button.text }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
